/**
 * @file
 * Provides javascript behaviors for social embeds.
 */

(function ($, Drupal, Cookies) {
  Drupal.behaviors.social_embed = {
    attach: function attach(context, settings) {

      /**
       * Prepare embed opt-in elements on initial page-loads
       */
      once('awSocialEmbed', '.js-social-embed-opt-in', context).forEach(function(currentElement) {
        let container = $(currentElement);
        let elementId = container.data('social-embed-id');
        let embedcode = settings['aw_social_embed'][elementId];
        let embedActive = container.find('[data-embed-active]').html();
        let embedNotActive = container.find('[data-embed-not-active]').html();
        let placeholder = container.find('.social-embed__placeholder');

        container.append(embedActive, embedNotActive);

        if(Cookies.get('allow_social_embed')) {
          container.addClass('social-embed--active')
          placeholder.append(embedcode);
        }
      });

      /**
       * Handle embed opt-in when checkbox is clicked
       */
      once('awSocialEmbedCheckbox', '.js-social-embed-opt-in .checkbox__input', context).
        forEach(function(currentElement) {
        currentElement.addEventListener('click', function () {
          let checkbox = $(this);
          $('.js-social-embed-opt-in').each(function() {
            let container = $(this);
            let elementId = container.data('social-embed-id');
            let embedcode = settings['aw_social_embed'][elementId];
            let placeholder = container.find('.social-embed__placeholder');

            setTimeout(function(){
              if (checkbox.hasClass('social-embed-opt-in')) {
                $('.social-embed-opt-out').prop('checked', true);
                placeholder.append(embedcode);

                container.addClass('social-embed--active');
                Cookies.set('allow_social_embed', '1');
              }
              if (checkbox.hasClass('social-embed-opt-out')) {
                $('.social-embed-opt-in').prop('checked', false);
                placeholder.empty();
                container.removeClass('social-embed--active');
                Cookies.remove('allow_social_embed');
              }
            }, 300);
          });
        });
      });

    }
  };
})(jQuery, Drupal, window.Cookies);
